import * as XLSX from "xlsx";
import { modelsProxyUrl } from "../../API/axiosInstance";
export const downloadCSV = (serverResponse) => {
  const headers = [
    "S.No",
    "Platform",
    "User Name",
    "DateTime",
    "Legality",
    "Language",
    "Section",
    "Intensity",
    "Sentiment",
    "Link",
    "Content",
    "Translation",
  ];

  const escapeCSVField = (field) => {
    if (!field && field !== 0) return "N/A";
    const stringField = String(field);
    return `"${stringField.replace(/"/g, '""')}"`;
  };

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "N/A"; // Fallback for undefined, null, or non-string values
    }
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const csvContent = [
    headers.join(","), // Header row
    ...serverResponse.map((data, index) => {
      const formattedDateTime = data.datetime
        ? data.datetime.replace("T", " ").split(".")[0].replace(" ", " / ")
        : "N/A";

      const formattedSections =
        Array.isArray(data.sections) && data.sections.length > 0
          ? data.sections
              .map((section) =>
                section.includes("Section")
                  ? section.split("Section ")[1]
                  : section
              )
              .join(", ")
          : "N/A";

      // Use title and titleTranslation for YOUTUBE platform
      const contentField =
        data.platform === "YOUTUBE"
          ? truncateText(data.title || "N/A", 400)
          : truncateText(data.content || "N/A", 400);

      const translationField =
        data.platform === "YOUTUBE"
          ? truncateText(data.titleTranslation || "N/A", 400)
          : truncateText(data.translation || "N/A", 400);

      return [
        index + 1,
        escapeCSVField(data.platform),
        escapeCSVField(data.postOwner),
        escapeCSVField(formattedDateTime),
        escapeCSVField(data.legality),
        escapeCSVField(data.languages),
        escapeCSVField(formattedSections),
        escapeCSVField(data.intensity),
        escapeCSVField(data.sentiment),
        escapeCSVField(data.link),
        escapeCSVField(contentField),
        escapeCSVField(translationField),
      ].join(",");
    }),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "table_data.csv");
  link.click();
};

export const downloadSimpleExcel = async (serverResponse) => {
  const SESSION_API_URL = "http://10.226.37.205:8000/session/create";
  const AWS_SESSION_API_URL = modelsProxyUrl("/session/create");

  try {
    // Build body in the format you showed:
    const payload = {
      timestamp: new Date().toISOString(), // Mongo-style ISO string
      posts: serverResponse.map((row) => ({
        link: row.link,
        content: row.content,
        sections: row.sections,
      })),
    };
    const token = localStorage.getItem("Token");
    const response = await fetch(AWS_SESSION_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error("Failed to create session. Status:", response.status);
      return;
    }

    const data = await response.json();
    const { sessionId } = data || {};

    if (!sessionId) {
      console.error(
        "Session created, but sessionId missing in response:",
        data
      );
      return;
    }

    // ---------- BUILD EXCEL DATA (AOA = Array of Arrays) ----------
    const headerRow = [
      "S.No",
      "SessionId",
      "Link",
      "Content",
      "correct_sections",
      "flag",
    ]; // no Section column

    const truncateText = (text, maxLength) => {
      if (!text || typeof text !== "string") return "N/A";
      return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    };

    const rows = serverResponse.map((row, index) => {
      const contentField =
        row.platform === "YOUTUBE"
          ? truncateText(row.title || "N/A", 400)
          : truncateText(row.content || "N/A", 400);

      return [
        index + 1, // S.No
        sessionId, // SessionId
        row.link || "N/A", // Link
        contentField, // Content
        "", // correct_sections (placeholder)
        "", // flag (placeholder)
      ];
    });

    const aoa = [headerRow, ...rows];

    // ---------- CREATE XLSX WORKBOOK ----------
    const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Triggers download in browser
    XLSX.writeFile(workbook, "table_data_simple.xlsx");
  } catch (error) {
    console.error("Error while creating session or downloading Excel:", error);
  }
};
